import { render, staticRenderFns } from "./Template2.vue?vue&type=template&id=70697710&scoped=true&"
import script from "./Template2.vue?vue&type=script&lang=js&"
export * from "./Template2.vue?vue&type=script&lang=js&"
import style0 from "./Template2.vue?vue&type=style&index=0&id=70697710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70697710",
  null
  
)

export default component.exports